import {get} from '../http';
import {GenericHttpError, throwInstanceNotFoundError, throwGenericValidationError} from '../../errors';

export default {

	getTenantByName(request) {
		const {authorizationToken, tenantName} = request;
		return get(`${__API_URL__}/tenant/v1/tenant/name/${tenantName}`, authorizationToken)
			.catch(error => {
				if (error instanceof GenericHttpError && error.status === 404) {
					throwInstanceNotFoundError();
				} else {
					throwGenericValidationError(error);
				}
			});
	},

} as ConfigTester.ValidationApi;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/api/config-tester/validation.ts